export default __webpack_public_path__ + "static/media/comptetitive-landscapes-template.22c65a3f.pptx";